import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Fade,
  Typography,
} from "@mui/material";
import ModalPDF from "../../components/ModalPDF";

const BotonDescarga = ({title, description, buttonText, background, onButtonClick}) => {

  const [openModal, setOpen] = useState(false);
  const [currentPdf, setCurrentPdf] = useState(null);
  const handleOpenModal = (archivo) => {
    setCurrentPdf(archivo);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <Box
      sx={{
        background: background,
        width: "100%",
        minHeight: "400px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: 2,
      }}
    >
      {/* Texto de presentación */}
        <Box>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 700,
              mb: 2,
              fontSize: {
                xs: "2rem",
                sm: "2.5rem",
                md: "3rem",
              },
            }}
          >
            {title}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              maxWidth: "650px",
              mx: "auto",
              color: "text.secondary",
              fontSize: {
                xs: "1rem",
                sm: "1.1rem",
              },
              lineHeight: 1.7,
            }}
          >
            {description}
          </Typography>
        </Box>
      

      {/* Botón */}

        <Button
          variant="contained"
          size="large"
          onClick={()=> handleOpenModal (onButtonClick)}
          sx={{
            mt: 4,
            px: 4,
            py: 1.4,
            borderRadius: 2,
            fontWeight: 600,
            textTransform: "none",
            transition: "all 0.8s ease",

            "&:hover": {
              transform: "translateY(-8px)",
              boxShadow: 4,
            },
          }}
        >
          {buttonText}
        </Button>

      <ModalPDF
        open={openModal}
        handleClose={handleCloseModal}
        pdfOriginal={currentPdf}
      />
    </Box>
  );
};

export default BotonDescarga;